export default {
  pullquote: {
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nobis alias fugit iste laboriosam nulla pariatur totam velit eum eaque, perferendis, dolores placeat natus explicabo suscipit repellendus non eveniet ipsum quo.',
    source: 'Alley Interactive',
    url: 'https://www.alleyinteractive.com',
  },
};
